import { Colors, Icon, Text } from '@amelio/ui-library';

import { useAmelioTranslations } from '@/hooks';

export interface CompletedCycleNoticeProps {
    dataTestId?: string;
}

export const CompletedCycleNotice = ({
    dataTestId = 'completed-cycle-notice',
}: CompletedCycleNoticeProps) => {
    const { t } = useAmelioTranslations();

    return (
        <div
            role={'status'}
            data-testid={dataTestId}
            className={
                'border-warning/50 bg-warning/10 inline-flex max-w-prose items-start gap-2 rounded-full border px-4 py-2'
            }
        >
            <Icon
                name={'essential-warning-2'}
                size={'sm'}
                color={Colors.WARNING}
                className={'mt-0.5 shrink-0'}
            />

            <Text size={'small'}>{t('cycleEvaluationGroupStepper.readOnlyNotice')}</Text>
        </div>
    );
};
